import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import TwinTable from '../../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { ColumnTableSchema } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { useParams } from 'react-router-dom'
import { useAddDoubleTableGreenRowRender } from '../../../../../../baseComponents/DoubleTable/functions'
import { CustomRenderColor, DeleteRow, EditRow } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { permissionCheck } from '../../../../../../baseComponents/PermissionChecker/function'
import { TableComponentProps } from '../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import ModalCEBuyTag from './ModalCEBuyTag'
import ModalDeleteBuyTag from './ModalDeleteBuyTag'
import { BuyTagModelType } from '@teinor/erp/types/company/order/buy/buyTag'

interface BuyTagsProps extends ComponentWithPermissions {}

const BuyTags: React.FC<BuyTagsProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('buyTags', 'Etiquetas de compra'),
        newText: t('newTag', 'Nueva etiqueta'),
    }
    return (
        <BaseScreenTable TableComponent={TableBuyTags} CreateModalComponent={ModalCEBuyTag} EditModalComponent={ModalCEBuyTag} DeleteModalComponent={ModalDeleteBuyTag} pageData={pageData} userPermissions={userPermissions} />
    )
}

interface TableBuyTagsProps extends TableComponentProps { }

const TableBuyTags: React.FC<TableBuyTagsProps> = ({ setTableInstance, setOpened, userPermissions }) => {
    const { t } = useTwinTranslation()
    const { id } = useParams()
    const { rowRenderer } = useAddDoubleTableGreenRowRender(id || '')
    const columns: ColumnTableSchema<BuyTagModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            sortable: true,
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Name') }
            }
        },
        {
            id: 'color',
            dataKey: 'color',
            label: t('color', 'Color'),
            customRender: (parameterValue) => <CustomRenderColor value={parameterValue} />
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} />
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]

    return (
        <TwinTable name='BuyTags' columns={columns} getDataFrom='/api/app/order/buy/tag/getAllBuyTags' setTableInstance={setTableInstance} rowRenderer={rowRenderer} hideLoadFiltersButton={true} onRowClick={(_id, rowData) => setOpened({
            type: 'edit',
            allRowData: rowData
        })} />
    )
}



export default BuyTags